// Root Object
export interface ApplicationQuestions {
  options: Options;
  classification: string | null;
  groupedQuestions: GroupedQuestions;
}

// Options Object
export interface Options {
  [key: string]: string; // E.g., "0": "No", "1": "Yes"
}

// Grouped Questions Object
export interface GroupedQuestions {
  [key: string]: QuestionGroup;
}

// Question Group Object
export interface QuestionGroup {
  name?: LocalizedText; // Optional name for the group
  questions: IQuestion[];
}

// Localized Text Object
export interface LocalizedText {
  en: string; // English version
  ar: string; // Arabic version
}

// Enum for Question Types
export enum QuestionType {
  YesNo = "yes-no",
  Checkbox = "checkbox",
  Text = "text",
  Radio = "radio",
}

// Enum for Required Fields
export enum RequiredField {
  No = "0",
  Yes = "1",
}

// Question Object
export interface IQuestion {
  question: LocalizedText;
  question_number: string;
  question_order: string;
  question_type: QuestionType;
  required: RequiredField;
  group_id: string;
  hasOtherAnswer: boolean;
  answers: Answer[];
}

// Answer Object
export interface Answer {
  id?: string; // Optional ID for the answer
  answer: LocalizedText;
  checked: boolean;
  children: Answer[]; // Nested answers for hierarchical options
}

const apiUrl = "https://dotmedica.com/applications/getApplicationQuestions";

// Fetch function to retrieve application questions from the API
export async function fetchApplicationQuestions(): Promise<ApplicationQuestions> {
  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: ApplicationQuestions = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching application questions:", error);
    throw error;
  }
}
